import { ClaimLabel, claimTable } from './tables/claim';
import { CustomerLabel, customerStatusTable } from './tables/customer-status';
import { InsuranceLabel, insuranceTable } from './tables/insurance';
import { PaymentLabel, paymentTable } from './tables/payment';
import { QuotationLabel, quotationTable } from './tables/quotation';
import { TaskPriorityLabel, taskPriorityTable } from './tables/task-priority';
import { TaskStatusLabel, taskStatusTable } from './tables/task-status';
import { Variant } from './utils';

export class TagDto<T> {
  label: keyof T;
  variant: Variant;
  value: keyof T;

  constructor(label: keyof T, table: Record<keyof T, [Variant, keyof T]>) {
    this.label = table[label][1];
    this.variant = table[label][0];
    this.value = label;
  }

  static getClaimTag(label: ClaimLabel) {
    const tag = new TagDto<typeof claimTable>(label, claimTable);
    return { ...tag, value: label };
  }

  static getInsuranceTag(label: InsuranceLabel) {
    const tag = new TagDto<typeof insuranceTable>(label, insuranceTable);
    return { ...tag, value: label };
  }

  static getQuotationTag(label: QuotationLabel) {
    const tag = new TagDto<typeof quotationTable>(label, quotationTable);

    return { ...tag, value: label };
  }

  static getTaskPriorityTag(label: TaskPriorityLabel) {
    const tag = new TagDto<typeof taskPriorityTable>(label, taskPriorityTable);
    return { ...tag, value: label };
  }

  static getTaskStatusTag(label: TaskStatusLabel) {
    const tag = new TagDto<typeof taskStatusTable>(label, taskStatusTable);

    return { ...tag, value: label };
  }

  static getCustomerStatusTag(label: CustomerLabel) {
    const tag = new TagDto<typeof customerStatusTable>(
      label,
      customerStatusTable,
    );
    return { ...tag, value: label };
  }

  static getPaymentStatusTag(label: PaymentLabel) {
    const tag = new TagDto<typeof paymentTable>(label, paymentTable);
    return { ...tag, value: label };
  }
}
